
import React, { useEffect, useState } from "react";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import {
  NotificationProvider,
  useNotifications,
} from "./Components/Context/NotificationContext";

import NotificationPopup from "./Components/Common/NotificationPopup";
import GlobalPopup from "./Components/Common/GlobalPopup";
import GlobalNotificationWatcher from "./Components/Common/GlobalNotificationWatcher";

import "./assets/scss/themes.scss";
import Route from "./Routes";

const getStoredUserId = () => {
  const directId = localStorage.getItem("userId");

  if (directId && directId !== "null" && directId !== "undefined") {
    return directId;
  }

  try {
    const user = JSON.parse(localStorage.getItem("user") || "{}");
    const id = user.id || user._id;

    return id ? String(id) : null;
  } catch (error) {
    console.error("Unable to read stored user:", error);
    return null;
  }
};

const GlobalPopupWrapper = () => {
  const { globalPopup, closeGlobalPopup } = useNotifications();

  return (
    <GlobalPopup
      show={globalPopup.show}
      message={globalPopup.message}
      onClose={closeGlobalPopup}
    />
  );
};

function App() {
  const [userId, setUserId] = useState(getStoredUserId);

  useEffect(() => {
    const syncUser = () => {
      const id = getStoredUserId();

      console.log("[App] Notification userId:", id);
      setUserId(id);
    };

    window.addEventListener("auth-user-updated", syncUser);
    window.addEventListener("storage", syncUser);

    return () => {
      window.removeEventListener("auth-user-updated", syncUser);
      window.removeEventListener("storage", syncUser);
    };
  }, []);

  return (
    <React.Fragment>
      <NotificationProvider userId={userId}>
        <GlobalNotificationWatcher />

        <Route />

        <NotificationPopup />

        <GlobalPopupWrapper />
      </NotificationProvider>

      <ToastContainer />
    </React.Fragment>
  );
}

export default App;
